// extracted by mini-css-extract-plugin
export default {"container":"Navbar_container__lMB+p","NavWidth":"Navbar_NavWidth__sNIgn","nav":"Navbar_nav__kPvUt","logo":"Navbar_logo__3H5Zh","navLinks":"Navbar_navLinks__qaxVB"};